export default {
    state: {
        roles: [],
        group_types: [],
        floors: [],
        notification_types: [],
        message_type: '',
        message: '',
        canned_messages: [],
        test_messages: []
    },

    mutations: {
        setMessageRoles(state, data) {
            state.roles = data;
        },

        setMessageGroupTypes(state, data) {
            state.group_types = data;
        },

        setMessageFloors(state, data) {
            state.floors = data;
        },

        setMessageNotificationTypes(state, data) {
            state.notification_types = data;
        },

        setMessageType(state, data) {
            state.message_type = data;
        },

        setMessage(state, data) {
            state.message = data;
        },

        resetMessage(state) {
            state.roles = [];
            state.group_types = [];
            state.floors = [];
            state.notification_types = [];
            state.message_type = '';
            state.message = '';
        }
    }
};